import React, { useState } from 'react';
import { plusIcon } from 'components/global/assets/plusIcon';
import { minusIcon } from 'components/global/assets/minusIcon';
import {
  AccordionContainer,
  AccordionHeader,
  AccordionTitle,
  AccordionIcon,
  AccordionContent,
  ContentWrapper
} from './styles/StyledComponents';

export const Accordion = ({ title, content }) => {
  const [isExpanded, setIsExpanded] = useState(false);

  const toggleAccordion = () => {
    setIsExpanded(prev => !prev);
  };

  return (
    <AccordionContainer>
      <AccordionHeader onClick={toggleAccordion}>
        <AccordionTitle>{title}</AccordionTitle>
        <AccordionIcon>{isExpanded ? minusIcon : plusIcon}</AccordionIcon>
      </AccordionHeader>
      <AccordionContent isExpanded={isExpanded}>
        <ContentWrapper>{content}</ContentWrapper>
      </AccordionContent>
    </AccordionContainer>
  );
};
